import { API } from "./api";

const REMOTE_IMAGE_RE = /^(https?:|data:)/i;

export function getPaymentProofSrc(member) {
  if (!member) return "";

  const rawPath = member.payment_proof_path || member.paymentProofPath || "";

  if (rawPath && REMOTE_IMAGE_RE.test(rawPath)) {
    return rawPath;
  }

  if (member.id && rawPath) {
    return `${API}/members/${member.id}/payment-proof?v=${encodeURIComponent(rawPath)}`;
  }

  return "";
}
